const LogoNavbar=({ onClick })=>{
  

    return(

        <div className="logoNavbar" onClick={onClick}>
                <div>
                <h1 className="task">TaskRanger</h1>
                </div>
                        
       </div> 
    )
}

export default LogoNavbar
